import axios from "@/libs/api.request";
// 获取列表
export const getB2BDetails = params => {
  return axios.request({
    url: "/finance/dblfinace",
    method: "get",
    params
  });
};

export const exportB2BDetails = params => {
  return axios.request({
    url: "/finance/dblfinace/export",
    method: "get",
    params
  });
};

export const createB2Bbill = data => {
  return axios.request({
    url: "/finance/dblfinace/create",
    method: "post",
    data
  });
};

// 获取优选抬头
export const getB2Bbill = params => {
  return axios.request({
    url: "/common/contractParam",
    method: "get",
    params
  });
};

// 同步数据
export const syncB2Bbill = params => {
  return axios.request({
    url: "/finance/dblfinace/sync",
    method: "get",
    params
  });
};

// 获取拆包信息
export const getB2BbillSplit = params => {
  return axios.request({
    url: `/finance/dblfinace/package/${params.airway_number}`,
    method: "get",
    params
  });
};

// 获取拆包信息
export const getB2BbillSplitDetail = params => {
  return axios.request({
    url: `/finance/dblfinace/packing`,
    method: "get",
    params
  });
};

export const getRate = id => {
  return axios.request({
    url: `/finance/dblfinace/rate/`+id,
    method: "get",
  });
};

export const saveRate = data => {
  return axios.request({
    url: "/finance/dblfinace/saveRate/"+data.id,
    method: "post",
		data
  });
};

export const getMultiRate = data => {
  return axios.request({
    url: "/finance/dblfinace/getMultiRate",
    method: "post",
		data
  });
};

export const saveMultiRate = data => {
  return axios.request({
    url: "/finance/dblfinace/saveMultiRate",
    method: "post",
		data
  });
};

export const preview = id => {
  return axios.request({
    url: `/finance/dblfinace/preview/`+id,
    method: "get",
  });
};